import React from "react";
import { graphql } from "gatsby";
import { Link, useTranslation } from "gatsby-plugin-react-i18next";

import { Seo } from "../components/seo";
import Layout from "../components/layout";

export default function NotFoundPage() {
  const { t } = useTranslation();

  const pageStyles = {
    paddingTop: 120,
    paddingBottom: 120,
  };

  return (
    <Layout>
      <div style={pageStyles}>
        <div className="container">
          <div className="row">
            <div className="col">
              <h1>{t("404_TITLE")}</h1>
              <p className="heroParagraph m-bottom-10">{t("404_MESSAGE")}</p>
              <Link to="/" className="btn btn-primary">
                {t("404_LINK")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export const Head = () => <Seo title={"Page not found"} />;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

